/* VITANNA · Comportamientos comunes de los módulos: aparición al scroll, flechas del carrusel de reseñas y revisión de formularios.
   Varias secciones cargan este archivo: solo la primera copia se ejecuta. */
(function () {
  'use strict';
  if (window.__vtUi) return;
  window.__vtUi = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pending = [];

  function check() {
    var limit = window.innerHeight * 0.92;
    pending = pending.filter(function (el) {
      if (el.getBoundingClientRect().top < limit) { el.classList.add('vt-in'); return false; }
      return true;
    });
  }

  function carousel(box) {
    var scope = box.closest('section') || box.parentNode;
    var prev = scope.querySelector('[data-vt-prev]');
    var next = scope.querySelector('[data-vt-next]');
    if (!prev || !next) return;
    function step() {
      var card = box.firstElementChild;
      return card ? card.getBoundingClientRect().width + 14 : 300;
    }
    function sync() {
      prev.disabled = box.scrollLeft < 4;
      next.disabled = box.scrollLeft + box.clientWidth >= box.scrollWidth - 4;
    }
    prev.onclick = function () { box.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); };
    next.onclick = function () { box.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); };
    box.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* Los mensajes vienen de la sección, en los atributos de cada campo. Sin este script, el navegador revisa con «required». */
  function contactForm(form) {
    if (form.getAttribute('data-vt-ready')) return;
    form.setAttribute('data-vt-ready', '1');
    form.noValidate = true;
    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-vt-field]'));
    var tried = false;

    function control(box) { return box.querySelector('input,select,textarea'); }
    function problem(box) {
      var input = control(box);
      if (input.type === 'checkbox') return input.checked ? '' : box.getAttribute('data-required');
      var value = input.value.trim();
      if (!value) return box.getAttribute('data-required');
      var digits = value.replace(/\D/g, '').length;
      if (input.type === 'tel' && (digits < 10 || digits > 13)) return box.getAttribute('data-format');
      return '';
    }
    function paint(box) {
      var text = problem(box);
      var note = box.querySelector('[data-vt-err]');
      var input = control(box);
      box.classList.toggle('is-bad', !!text);
      note.hidden = !text;
      note.querySelector('span').textContent = text;
      if (text) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
      return !text;
    }

    fields.forEach(function (box) {
      var input = control(box);
      var again = function () { if (tried) paint(box); };
      input.addEventListener('input', again);
      input.addEventListener('change', again);
    });
    form.addEventListener('submit', function (event) {
      tried = true;
      var bad = fields.filter(function (box) { return !paint(box); });
      if (bad.length) {
        event.preventDefault();
        control(bad[0]).focus();
        return;
      }
      var send = form.querySelector('[type="submit"]');
      if (send) send.setAttribute('aria-busy', 'true');
    });
  }

  function boot(scope) {
    if (!reduce) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-vt-reveal]:not(.vt-in)'), function (el) { pending.push(el); });
      check();
    }
    Array.prototype.forEach.call(scope.querySelectorAll('[data-vt-carousel]'), carousel);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-vt-form]'), contactForm);
  }

  function start() {
    document.documentElement.classList.add('vt-js');
    boot(document);
    if (!reduce) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; check(); });
      }, { passive: true });
      window.addEventListener('resize', check);
      window.addEventListener('hashchange', check);
    }
    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
